<template>
  <div class="header">
    <div class="row">
      <div class="col">
        <span>
          <a v-if="!readOnly" class="text-white" @click="edit"><i class="fa fa-pencil"></i></a>
          <span>{{ description }}</span>
          <span style="padding-left: 8px;">{{ ' | ' }}</span>
        </span>
        <template v-if="!showCarbon">
          <span class="badge">{{ dimensions }}</span>
          {{ ' | ' }}
          <span class="badge">{{ weight }}</span>
        </template>
        <span v-else class="badge">{{ carbon }}</span>
        <template v-if="lot">
          <span>{{ ' | ' }}</span>
          <span class="badge">Lot #:  {{ lot }}</span>
        </template>
        <div v-if="!readOnly" class="float-right">
          <button type="button" class="close text-white" data-dismiss="alert" aria-label="Close" @click="remove">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { safeNumber } from "./shippingLvlUtils";
const WEIGHT_UNIT = Object.freeze({
  1: "Kg",
  2: "Lb"
});

const DIM_UNIT = Object.freeze({
  1: "m",
  2: "cm",
  3: "ft",
  4: "in",
});

export default {
  name: "ShippingLvlHeader",
  props: ['parent', 'idx', 'readOnly', 'showCarbon', 'level'],
  computed: {
    component() {
      if(!this.parent || !this.parent.components) return null;
      return this.parent.components[this.idx];
    },
    invalid() {
      return !this.component || !this.component.description;
    },
    description() {
      if(this.invalid) return "";
      return `${this.component.quantity}x ${this.component.description}`;
    },
    dimensions() {
      if(this.invalid) return "";
      const dim = DIM_UNIT[this.component.dimensionunit];
      return `${safeNumber(this.component.length)} x ${safeNumber(this.component.width)} x ${safeNumber(this.component.height)} ${dim}`;
    },
    weight() {
      if(this.invalid) return "";
      return `${safeNumber(this.component.weight)} ${WEIGHT_UNIT[this.component.weightunit]} per unit`;
    },
    carbon() {
      if(this.invalid || !this.showCarbon || !this.component.carbonEmissionPerUnit) return "";
      let value = this.component.carbonEmissionPerUnit;
      if(this.component.carbonEmissionPerUnit < 1) {
        value *= 1000;
        return `${safeNumber(value)} g of CO2 per unit`;
      }
      return `${safeNumber(value)} kg of CO2 per unit`;
    },
    lot() {
      if(this.invalid || !this.component.lot) return "";
      return this.component.lot;
    },
  },
  methods: {
    edit() {
      this.$modal.show("shipping-lvl-modal", { component: this.component, level: this.level });
    },
    remove() {
      this.parent.components.splice(this.idx, 1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// ShippingLvlHeader.vue?e6258b40